import React from "react";
import { useNavigate } from "react-router-dom";
import PrivateLayout from "../../layouts/PrivateLayout";

function TournamentsHub() {
  const navigate = useNavigate();
  const backgroundImage = "/ww-wallpaper.webp";

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <PrivateLayout backgroundImage={backgroundImage}>
      <div className="flex flex-col items-center justify-center h-full text-center text-white bg-black/40">
        <h1 className="text-4xl md:text-5xl font-bold mb-8 drop-shadow-lg">
          Tournaments
        </h1>
        <p className="text-lg md:text-xl mb-10 max-w-xl drop-shadow">
          Choose what you want to manage or explore in the tournament realm.
        </p>
        <div className="flex flex-col md:flex-row gap-4 md:gap-8">
          <button
            onClick={() => handleNavigate("/tournaments/active")}
            className="px-8 py-4 rounded-lg bg-blue-600 hover:bg-blue-700 transition-colors text-lg font-semibold shadow-lg"
          >
            Active Tournaments
          </button>
          <button
            onClick={() => handleNavigate("/past-tournaments")}
            className="px-8 py-4 rounded-lg bg-gray-700 hover:bg-gray-800 transition-colors text-lg font-semibold shadow-lg"
          >
            Past Tournaments
          </button>
          <button
            onClick={() => handleNavigate("/manage-tournaments")}
            className="px-8 py-4 rounded-lg bg-indigo-600 hover:bg-indigo-700 transition-colors text-lg font-semibold shadow-lg"
          >
            Manage Tournaments
          </button>
        </div>
      </div>
    </PrivateLayout>
  );
}

export default TournamentsHub;

